module.exports = __webpack_public_path__ + "img/tarjeta.af445c87.svg";